/**
 * SnapshotHeader — bandeau autonome pour la page de consultation d'un
 * snapshot (nom du rapport, client, période). Ne dépend pas d'AppLayout.
 */
interface SnapshotHeaderProps {
  reportName: string
  clientName: string
  periodStart: string
  periodEnd: string
}

export function SnapshotHeader({ reportName, clientName, periodStart, periodEnd }: SnapshotHeaderProps) {
  return (
    <header
      className="flex w-full items-center justify-between border-b px-6 py-4"
      style={{ borderColor: '#E2E4ED', backgroundColor: '#fff' }}
    >
      <div>
        <h1 className="text-lg font-semibold" style={{ color: '#1B2559' }}>
          {reportName}
        </h1>
        <p className="text-sm" style={{ color: '#8B8FA7' }}>
          {clientName}
        </p>
      </div>
      <div className="text-sm" style={{ color: '#8B8FA7' }}>
        {periodStart} – {periodEnd}
      </div>
    </header>
  )
}
